// src/components/ProtectedRoute.jsx
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { RoleContext } from '../Contexts/RoleContext';
import { UserContext } from '../Contexts/LoginContext';

const ProtectedRoute = ({ allowedRoles, children }) => {
  const { role } = useContext(RoleContext);
  const { username } = useContext(UserContext);

  if (!username) {
    return <Navigate to="/" replace />; // not logged in
  }

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
